export default function GradientIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="16"
      viewBox="0 0 20 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id="themeGradient"
          x1="10"
          y1="0"
          x2="10"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.2" />
        </linearGradient>
      </defs>
      <rect width="20" height="16" rx="2" fill="url(#themeGradient)" />
    </svg>
  );
}
